module.exports = function() {
  return new Worker(__webpack_public_path__ + "ee120c6a0ae616f2f327.worker.js");
};